import Timeline from "./Timeline";

function TrackResult({ data, onBack }) {
    return (
        <div className="track-result-box">
            <div className="track-header">
                <h2>Tracking Details</h2>
                <button className="reset-btn" onClick={onBack}>
                    ← Back
                </button>
            </div>

            <div className="order-summary">
                <p><strong>Order No:</strong> {data.order_number}</p>
                {data?.courier_name && (
                <p><strong>Courier:</strong> {data.courier_name}</p>
                )}

                {data?.awb_number && (
                <p><strong>AWB:</strong> {data.awb_number}</p>
                )}
                <p><strong>Payment:</strong> {data.payment_type}</p>
                <p>
                    <strong>Status:</strong>{" "}
                    <span className={`status ${data.status}`}>
                        {data.status}
                    </span>
                </p>
            </div>

            <h3 className="timeline-title">Shipment Timeline</h3>
            <Timeline history={data.history} />
        </div>
    );
}

export default TrackResult;
